import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, signal, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ReelsService } from "@src/app/servicios/reels.service";
import { first, Subscription } from "rxjs";
import { ConfigService } from "src/app/servicios/config/config.service";
import { PlatformService } from "src/app/servicios/platform/platform.service";
import { SidenavService } from "../../servicios/sidenav/sidenav.service";
import { ReelsComponent } from "../reels/reels.component";

@Component({
  selector: "app-home-reels",
  templateUrl: "./home-reels.component.html",
  styleUrls: ["./home-reels.component.css"],
  imports: [ReelsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeReelsComponent implements OnInit, OnDestroy {
  @ViewChild("container", { static: false }) container: ElementRef;
  arraLikesComents = signal(new Map<number, any>());
  noticiasFijadas = signal([]);
  likesNoticias = signal([]);
  ads = signal([]);
  constantesGlobales;
  entradillaVisible = false;
  rrssVisible = false;
  userLogin: any;
  likesComents = signal([]);
  scrollSub: Subscription;
  portadaReels: boolean = false;

  numLikes = signal(0);
  numComents = signal(0);
  likesUser: boolean;

  // animaciones = ['zoomInOut', 'slideFromCenter', 'zoomOutIn', 'slideFromCenterReverse'];
  animaciones = ["zoomInOut", "zoomOutIn"];

  constructor(
    private sidenav: SidenavService,
    private elementRef: ElementRef,
    public dialog: MatDialog,
    private platformService: PlatformService,
    private configService: ConfigService,
    private reelsService: ReelsService,
  ) {
    this.constantesGlobales = this.configService.getConstantesGlobales();
    const configPrensa = configService.getConfigPrensa();
    if (configPrensa) {
      configPrensa.pipe(first()).subscribe((config) => {
        if (config && config.general["app-home"].portada_reels_movil === "true") {
          this.portadaReels = true;
        }
      });
    }
    this.elementRef.nativeElement.style.setProperty("--background-color", this.constantesGlobales.color);
  }

  ngOnInit(): void {
    if (this.platformService.isBrowser()) {
      // overflow:hidden en el body no bloquea de forma fiable el scroll táctil en iOS Safari:
      // el dedo sigue desplazando la página por debajo de reels. position:fixed sí lo bloquea,
      // pero requiere fijar "top" explícitamente. Home se destruye siempre al entrar aquí
      // (@if/@else en device-based, o navegación de ruta a /reels), así que no hay una página
      // de fondo que preservar en su scroll: reels arranca siempre desde arriba.
      document.body.style.top = "0";
      document.body.classList.add("no-scroll");
    }

    this.sidenav.setIsScrolled(false);
    this.sidenav.setLogoVisibility(false);
  }

  ngOnDestroy(): void {
    if (this.platformService.isBrowser()) {
      this.sidenav.setIsScrolled(false);
      this.sidenav.setLogoVisibility(false);
      document.body.classList.remove("no-scroll");
      document.body.style.top = "";
      // Sin scrollTo manual: al salir de reels siempre se monta una vista nueva (home fresca o
      // la restauración propia del router), no se vuelve a una página que se dejó a medio scroll.
    }
  }
}
